import React, { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import {PiPhosphorLogoFill} from 'react-icons/pi'
import {FaTimes} from 'react-icons/fa'
import {AiOutlineMenu} from 'react-icons/ai/'
import Navbar2 from './Navbar2'
import {GiHouse} from 'react-icons/gi'
import { useContext } from 'react'
import { userContext } from '../App'
const Navbar = (props) => {
  const [search,setsearch]=useState('')
function hand(e){
  e.preventDefault()
  setsearch(e.target.value)
  console.log(search);
}
    const [open,setopen]=useState(false)
    const handler=()=>{
        setopen((prev)=>!prev)
    }
    console.log(open);
    
    const main=useNavigate()
    function work(){
      main('/')
    }
    const [find,type,onsearch]=useContext(userContext)
  return (
    <>
    <Navbar2 />
    <div className='bg-gray-800 shadow-xl z-50 top-12 relative' style={{position:'fixed',width:'100%'}}>
      <div className='mx-auto px-4 sm:px-6 lg:px-8'>
        <div  className='flex items-center justify-between h-16'>
            <div className='flex items-center lg:text-4xl text-white sm:text-xl cursor-pointer 'onClick={work} ><PiPhosphorLogoFill className=' w-15 h-12 ' />booking</div>
            <div className=' lg:px-36 justify-between lg:bold md:text-sm font-bold hidden md:block'> 
            {/* Input search */}
       <span className='lg:mx-8 md:mx-1 relative  '><input type='text' placeholder='Search items' className=' lg:w-96 h-10 border-red-950 lg:px-5 md:w-14 md:rounded-sm' value={find} onChange={type} />
<button className=' bg-blue-600 lg:h-10 lg:w-24 shadow-lg rounded-sm text-white md:h-10' onClick={()=>onsearch(find)}>Search</button></span>
            <NavLink to='/Hostel' className=' text-yellow-50 hover:bg-gray-600 hover:text-white px-3 py-4 rounded-md lg:mx-1 md:ml-1'> HOSTEL</NavLink>
            <NavLink to='/Apartment' className=' text-yellow-50 hover:bg-gray-600 hover:text-white px-3 py-4 rounded-md lg:mx-1 md:ml-1'>APARTMENT</NavLink>
            <NavLink to='/Homestel' className=' text-yellow-50 hover:bg-gray-600 hover:text-white px-3 py-4 rounded-md lg:mx-1 md:ml-1'>HOMESTEL</NavLink>
            <NavLink to='/Guesthouse'  className=' text-yellow-50 hover:bg-gray-600 hover:text-white px-3 py-4 rounded-md lg:mx-1 md:ml-1'>GUEST HOUSE</NavLink>
            </div>
            <button onClick={handler} className='w-25 h-25 lg:hidden inline-flex items-center justify-end p-2 rounded-md text-gray-400 hover:white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white'>
            <span className='sr-only'> open main mainu</span>
            {open==true?<FaTimes  className='w-25 h-25 '/>:<AiOutlineMenu className='w-25 h-25'/>}
        </button>
        </div>
        </div>
    {open==true?<div className='md:hidden relative'>
<div className='ox-2 pt-2 pb-3 space-y-1 sm-px-3'>
<NavLink to='/Hostel' className='text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base ' >HOSTEL</NavLink>
<NavLink to='/Apartment' className=' text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base'>APARTMENT</NavLink>
<NavLink to='/Homestel' className=' text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base'>HOMESTEL</NavLink>
<NavLink to='/Guesthouse' className=' text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base'>GUEST HOUSE</NavLink>
<span className=' mx-4'><input type='text' placeholder='Search items' className=' w-60 h-10 rounded-sm shadow-md' value={find} onChange={type} />
<button className=' bg-blue-600 h-11 w-20 text-white rounded-sm shadow-lg ' onClick={handler}>Search</button></span>
</div>
    </div>:<div>
      {null}
      </div>}
    </div>
    </>
  )
}

export default Navbar
